class Configuracao {
    constructor() {
        this.id = null;
        this.idCliente = null;
        this.idUsuario = null;
        this.idBolTomadorNaoInformado = null;
        this.nfDiasEmissaoRetroativa = null;
        this.nfPrazoDiasSubstituicao = null;
        this.idBolHabilitaCnaeNf = null;
        this.idBolAutonomoAliqZero = null;
        this.idBolSimplesNacAliqZero = null;
        this.idSeriePadrao = null;
        this.aliquotaMinima = null;
        this.aliquotaMaxima = null;
        this.idBolRetencaoFontePessoaFisica = null;
        this.idBolDesabilitarCredencAvulsa = null;
        this.idBolSelTomadorDiferente = null;
        this.idBolDecRetifAnalise = null;
        this.idBolRecusaDeclaracao = null;
        this.msgImuneIssqn = null;
        this.msgMei = null;
        this.msgOptanteSimples = null;
        this.msgDapsRecolhidoFora = null;
        this.msgAutenticidadeNfse = null;
        this.msgDapsRecolhidoSede = null;
        this.msgRetencaoMunicipio = null;
        this.msgAutonomo = null;
        this.msgPagaIssNotaFiscal = null;
        this.urlSistema = null;
        this.msgEmailNovoUsuario = null;
        this.msgEmailCancelamentoNota = null;
        this.msgEmailEmissaoNota = null;
        this.msgEmailEmissaoDaps = null;
        this.contaEmail = null;
        this.msgRetencaoForaMunicipio = null;
        this.msgIsentoIssqn = null;
        this.idBolDamDecSimplificada = null;
        this.idBolAnaliseCreden = null;
        this.idBolIntermediario = null;
        this.idBolManifestacao = null;
        this.nfManifestacaoPrazoDias = null;
        this.nfManifestacaoTipoPessoa = null;
        this.idBolFechamentoRetroativo = null;
        this.qtdeCompetenciasFechamentoRetroativo = null;
    }
}
export default Configuracao;